import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { EditPolicyComponent } from '../../../../../forms/dynamic-forms/edit-policy-form/edit-policy.component';
import { PolicyErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { ActivatedRoute , RouterModule } from '@angular/router';
import { ModalOptions, User } from '@mapfre-design-library/src/public_api';
import { EditPolicyService } from './../../../../../../_services/forms/create-account/edit-policy.service';
import { AddPolicyDataService } from './../../../../../../_services/signup-process-service/add-policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicyErrorSvgComponent, EditPolicyComponent, MapfreButtonComponent, MapfreModalComponent],
  selector: 'app-edit-policy-details',
  templateUrl: './edit-policy-details.component.html',
})
export class EditPolicyDetailsComponent implements OnInit {
  editPolicyDetails: any[];
  whereToFindModalOptions: ModalOptions;
  user: User = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private addPolicyDataService: AddPolicyDataService,
    editPolicyService: EditPolicyService
  ) {
    this.editPolicyDetails = editPolicyService.getInputs();
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small modal-dialog center-on-page',
      additionalButtonClasses: 'link-button small blue-link',
      animatePosition: 'bottom',
      buttonCopy: 'MODAL_WHERE_CAN_I_LINK',
      modalId: 'helpModal',
      modalTranslateCopy: 'MODAL_WHERE_CAN_I_TITLE',
      typeOfModal: 'default',
      modalName: 'edit-policy_Where_To_Find_Options',
    });
  }

  ngOnInit() {
    this.addPolicyDataService.$newPolicy.subscribe((userAndPolicy) => {
      this.user = userAndPolicy;
    });
  }

}
